const MAX_SCAN_RATE_FOR_BYB_IQ = 0.9;

const DEFAULT_SCAN_FREQUENCY_WEIGHT = 0.9;

const computeScanScore = (
  scanRate: number,
  scanFrequencyWeight = DEFAULT_SCAN_FREQUENCY_WEIGHT
): number => {
  return Number(((scanRate * 100) / scanFrequencyWeight).toFixed(2)) || 0;
};

const computeScanScoreForBybIq = (
  scanRate: number,
  scanFrequencyWeight = DEFAULT_SCAN_FREQUENCY_WEIGHT
): number => {
  return computeScanScore(
    Math.min(scanRate, MAX_SCAN_RATE_FOR_BYB_IQ),
    scanFrequencyWeight
  );
};

const computeScanRateFromScanScore = (
  scanScore: number,
  scanFrequencyWeight = DEFAULT_SCAN_FREQUENCY_WEIGHT
): number => {
  if (scanScore <= 0) {
    return 0;
  }

  return Number(((scanScore * scanFrequencyWeight) / 100).toFixed(2)) || 0;
};

const isScanRateScoreMaxed = (scanScore: number): boolean => {
  return scanScore >= computeScanScore(MAX_SCAN_RATE_FOR_BYB_IQ, DEFAULT_SCAN_FREQUENCY_WEIGHT);
};

export {
  MAX_SCAN_RATE_FOR_BYB_IQ,
  DEFAULT_SCAN_FREQUENCY_WEIGHT,
  computeScanScore,
  computeScanScoreForBybIq,
  computeScanRateFromScanScore,
  isScanRateScoreMaxed,
};

